export default {
  'createbusinessprofile.createbusinessprofile': 'ایجاد پروفایل تجاری',
};
